// Contato central da Clima Branca (ajuste aqui quando tiver o número oficial)
export const SUPPORT_WHATSAPP = "+55 21 99999-9999";
export const SUPPORT_PHONE = "+55 21 99999-9999";
